import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./PracticePerfectProgress.css";
import Spinner from "../../Spinner/Spinner";
import loadingIcon from "../../Spinner/loadingIcon.gif";
import { handleException } from "../../../app/util/util";
import { PPRetakeQuizDialog } from "../PracticePerfectVideos/PPQuizTaker/PPQuizRetakeDialog";
export default function PPVideoQuizProgress(props) {
  var ppProgrPageInfo = props.ppProgrPageInfo;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const { isbn } = useParams();
  const history = useHistory();
  const [ppVideoProgResults, setPpVideoProgResults] = useState([]);
  const [isPpVideoProgLoading, setIsPpVideoProgLoading] = useState(true);
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  const fetchVideoProgDetails = () => {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          themisSubjectAreaId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          ppSubjectAreaTagId: ppProgrPageInfo.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: ppProgrPageInfo.SATagId,
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/managePP/getVideoQuizProgress`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.ppQuizResultVOList) {
            var ppQuizResultList = Array.isArray(data.ppQuizResultVOList)
              ? data.ppQuizResultVOList
              : [data.ppQuizResultVOList];
            setPpVideoProgResults(ppQuizResultList);
          }
          setIsPpVideoProgLoading(false);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  useEffect(() => {
    fetchVideoProgDetails();
  }, []);
  const onHandleTakeQuiz = (subTopictagId) => {
    localStorage.removeItem("ppQuizInstances");
    history.push(
      `/pp-quiz/graded/${isbn}/${subTopictagId}/${ppProgrPageInfo.SATagId}/video`,
    );
  };
  const onHandleContinueQuiz = (video) => {
    localStorage.setItem("ppQuizInstances", JSON.stringify(video));
    history.push(
      `/pp-quiz/graded/${isbn}/${video.subTopicTagId}/${ppProgrPageInfo.SATagId}/video`,
    );
  };
  const onHandleRetakeQuiz = async (subTopictagId) => {
    localStorage.removeItem("ppQuizInstances");
    history.push(
      `/pp-quiz/graded/${isbn}/${subTopictagId}/${ppProgrPageInfo.SATagId}/video`,
    );
  };
  const onHandleQuizReview = (video) => {
    history.push(
      `/pp-quiz/results/${isbn}/${video.subTopicTagId}/${ppProgrPageInfo.SATagId}/${video.instanceId}`,
    );
  };
  function ContinueQuizButton({ video }) {
    return (
      <p className="ppVideoProgQuizUrlTxt">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onHandleContinueQuiz(video);
          }}
        >
          Continue Quiz
        </a>
      </p>
    );
  }
  const VideoQuizProgrVideoButton = (video) => {
    if (video.completedDate) {
      if (
        parseInt(video.instanceId) > parseInt(video.incompleteQuizInstanceId)
      ) {
        <>
          <div className="mb-3">
            <PPRetakeQuizDialog
              onHandleReviewQuiz={() => onHandleQuizReview(video)}
              details={false}
              video={video}
              onHandleRetakeQuizz={() =>
                onHandleRetakeQuiz(video.subTopicTagId)
              }
            />
          </div>
        </>;
      } else if (
        parseInt(video.incompleteQuizInstanceId) > parseInt(video.instanceId)
      ) {
        return <ContinueQuizButton video={video} />;
      }
      return (
        <>
          <div className="mb-3">
            <PPRetakeQuizDialog
              onHandleReviewQuiz={() => onHandleQuizReview(video)}
              details={false}
              video={video}
              onHandleRetakeQuizz={() =>
                onHandleRetakeQuiz(video.subTopicTagId)
              }
            />
          </div>
        </>
      );
    }
    if (video.incompleteQuizInstanceId) {
      if (!video.instanceId) {
        return <ContinueQuizButton video={video} />;
      }
      return <ContinueQuizButton video={video} />;
    }
    return (
      <p className="ppVideoProgQuizUrlTxt">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onHandleTakeQuiz(video.subTopicTagId);
          }}
        >
          Take Quiz
        </a>
      </p>
    );
  };
  return (
    <>
      <Spinner
        loading={isPpVideoProgLoading}
        imageSrc={loadingIcon}
        imageStyle={{ marginTop: "20%", width: "50px" }}
        overlayBackground="rgba(0,0,0,0)"
      />
      {isPpVideoProgLoading === false && (
        <>
          <div className="mt-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
            <p className="ppVideoProgTitle">
              Your most recent attempt on the quizzes for all videos
            </p>
          </div>
          {ppVideoProgResults.map((ppVideo) => {
            return (
              <>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                  <div className="mb-1">
                    <div className="ppVideoProgrVideoNames col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                      {ppVideo.customerFacingSubTopicName}
                    </div>
                  </div>
                  <div className="progress ppVideoProgrVideoProgress mb-1">
                    {ppVideo.score === undefined ? (
                      <div className="progress-bar ppVideoProgrVideoProgressBarNo">
                        No Score
                      </div>
                    ) : Number(ppVideo.score) > 0 ? (
                      <>
                        <div
                          className="progress-bar ppVideoProgrVideoProgressBar"
                          style={{ width: Number(ppVideo.score) + "%" }}
                        >
                          {Number(ppVideo.score) > 16
                            ? Number(ppVideo.score).toFixed(2) + "%"
                            : null}
                        </div>
                        {Number(ppVideo.score) > 16 ? null : (
                          <div className="progress-bar ppVideoProgrVideoProgressBarLess16">
                            {Number(ppVideo.score).toFixed(2) + "%"}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="progress-bar ppVideoProgrVideoProgressBarZero">
                        {ppVideo.score + "%"}
                      </div>
                    )}
                  </div>
                  {VideoQuizProgrVideoButton(ppVideo)}
                </div>
              </>
            );
          })}
          <hr className="w-100"></hr>
        </>
      )}
    </>
  );
}
